import { Component, OnInit, inject, model, signal } from '@angular/core';
import { AdvertisingService } from './services/advertising.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-advertising',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './advertising.component.html',
  styleUrl: './advertising.component.css'
})
export class AdvertisingComponent implements OnInit {
  service = inject(AdvertisingService)

  ngOnInit(): void {

  }
}
